export const matchMediaMDUp = window.matchMedia('(min-width: 768px)');
export const matchMediaLGDown = window.matchMedia('(max-width: 991px)');
export const matchMediaLGUp = window.matchMedia('(min-width: 992px)');
export const matchMediaXlDown = window.matchMedia('(max-width: 1199px)');
export const matchMediaXlUp = window.matchMedia('(min-width: 1200px)');